const features = [
  {
    title: '暗网安全入门',
    desc: '覆盖从零到一的暗网入门知识体系，无论你是完全新手还是有一定基础，都能找到适合的教程内容。',
    icon: 'ri-graduation-cap-line',
    color: 'primary',
  },
  {
    title: '最新网址导航',
    desc: '每周更新暗网.onion网址，人工验证可用性，提供分类索引与失效提醒，解决暗网链接频繁变动的问题。',
    icon: 'ri-compass-discover-line',
    color: 'secondary',
  },
  {
    title: '安全访问保障',
    desc: '详细的安全访问策略与防护指南，涵盖VPN搭配、PGP加密、防钓鱼技巧与匿名环境搭建全方案。',
    icon: 'ri-shield-flash-line',
    color: 'accent',
  },
  {
    title: '吃瓜爆料聚合',
    desc: '匿名投稿通道保障信息源安全，每日更新暗网社区热点事件与最新吃瓜内容，一站式信息聚合。',
    icon: 'ri-sparkling-line',
    color: 'primary',
  },
  {
    title: '工具下载指引',
    desc: 'Tor浏览器、I2P、PGP工具等暗网必备软件的最新版本下载指引与配置教程，避免下载到恶意仿冒版本。',
    icon: 'ri-download-cloud-line',
    color: 'secondary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          本站特色
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          五大核心优势，打造最全面的暗网中文指南平台
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5 text-center group transition-all duration-200"
            >
              <div
                className={`w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-4 ${
                  f.color === 'primary'
                    ? 'bg-primary-500/10 text-primary-400'
                    : f.color === 'accent'
                    ? 'bg-accent-500/10 text-accent-400'
                    : 'bg-secondary-500/10 text-secondary-400'
                }`}
              >
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-2">{f.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}